import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ClientSearchResultWrapper = styled.div`
  margin: 19px 0px 39px;

  ${responsive.MOBILE`
    margin: 19px 0px 0px;
  `}

  .form-header {
    background-color: ${COLORS.primary_light_blue2};
    padding: 10px 16px;

    ${responsive.MOBILE`
      padding: 10px 8px;
    `}
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }
  }

  .MuiPaper-root.MuiTableContainer-root {
    border-radius: 0;
  }

  .MuiGrid2-root {
    width: 100%;
  }
  .company-name-link {
    width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .cell-city-type {
    min-width: 200px;
  }
`;
